/**
 * User: WangMeng
 * Date: 2018-07-20
 * Time: 9:59
 * Desc: 行业整体衰退
 */

import styles from './common.scss';
import React from 'react';
import { Spin } from 'antd';
import { formatNormalNumber } from '../../../../../utils/formatter';
import BBDLineBar from '../../../../common/echarts/BBDLineBar';
import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';

export default class IndustryRecession extends BaseDangerDetail {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            assetOption: {},
            incomeOption: {}
        };
    }

    formatResponse = (data) => {
        let category = [], assetData = [], incomeData = [], industry = '';
        data && data.forEach(d => {
            industry = d.industry;
            category.push(d.reportYear);
            assetData.push(formatNormalNumber(d.asset));
            incomeData.push(formatNormalNumber(d.bussinessIncome));
        });

        return {
            industry,
            assetOption: {
                category,
                lineData: assetData
            },
            incomeOption: {
                category,
                lineData: incomeData
            }
        };
    };

    render() {
        const { loading, assetOption, incomeOption, industry } = this.state;

        return (
            <div >
                <div className="sub-title">{industry}公司总资产</div>
                <div className={styles.industryChart}>
                    {
                        loading ?
                            <Spin /> :
                            <BBDLineBar option={assetOption}/>
                    }
                </div>

                <div className="sub-title margin-top-20">{industry}公司总营业收入</div>
                <div className={styles.industryChart}>
                    {
                        loading ?
                            <Spin /> :
                            <BBDLineBar option={incomeOption}/>
                    }
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/danger/IndustryRecession.jsx